import { AuditLogDto, AuditLogRequest } from "../types/AuditLog";
import { FileExtensionCount } from "../types/DocumentItem";
import apiClient from "../utils/apiClient";

export const getAuditLogs = async (auditLogRequest? :AuditLogRequest): Promise<AuditLogDto[]> => {
    const response = await apiClient.post<AuditLogDto[]>(`/portal/auditLog`, auditLogRequest);
    return response.data;
};

export const getAuditLogDetails = async (params: { auditLogId: number; source: string }): Promise<AuditLogDto> => {
    const response = await apiClient.get<AuditLogDto>(`/portal/auditLog/${params.auditLogId}`, { params: { source: params.source } });
    return response.data;
};

export const getFileExtensionCount = async(userId: number): Promise<FileExtensionCount[]> =>{
  const response = await apiClient.get<FileExtensionCount[]>(`/portal/auditLog/fileExtension-count/${userId}`);
  return response.data;
}